/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Events_Not_In_Team_Project_ConfirmInputs */

const en_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const fr_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const de_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ХОРОШО`)
};

const es_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DE ACUERDO`)
};

const zh_cn2_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_team_sync_events_not_in_team_project_confirm = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "OK" |
*
* @param {Team_Sync_Events_Not_In_Team_Project_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_events_not_in_team_project_confirm = /** @type {((inputs?: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Events_Not_In_Team_Project_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_events_not_in_team_project_confirm(inputs)
	if (locale === "de") return de_team_sync_events_not_in_team_project_confirm(inputs)
	if (locale === "it") return it_team_sync_events_not_in_team_project_confirm(inputs)
	if (locale === "ru") return ru_team_sync_events_not_in_team_project_confirm(inputs)
	if (locale === "es") return es_team_sync_events_not_in_team_project_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_events_not_in_team_project_confirm(inputs)
	if (locale === "ja") return ja_team_sync_events_not_in_team_project_confirm(inputs)
	if (locale === "hi") return hi_team_sync_events_not_in_team_project_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_events_not_in_team_project_confirm(inputs)
	return en_team_sync_events_not_in_team_project_confirm(inputs)
});